import { useConversation } from "@/api/services/admin/conversation";
import { TopPage } from "@/components/elements/TopPage";
import { InputMsg } from "@/features/chat/components/InputMsg";
import { NoneSelectedRoom } from "@/features/chat/components/NoneSelectedRoom";
import { Room as RoomBase } from "@/features/chat/components/Room";
import { RoomHead } from "@/features/chat/components/RoomHead";
import { RoomList } from "@/features/chat/components/RoomList";
import { ChatProvider } from "@/features/chat/providers/ChatProvider";
import { SocketProvider } from "@/providers/SocketProvider";
import { AppRoutes } from "@/routes/config";
import { isNumber } from "@/utils/number";
import { Box, Stack, styled } from "@mui/material";
import { FC, useEffect, useMemo, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

type TChatPageProps = {};

const FlexRoom = styled(RoomBase)`
  flex: 1;
  min-height: 0;
`;

export const ChatPage: FC<TChatPageProps> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const contentWrapperRef = useRef<HTMLDivElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const { data: conversationResult, isLoading, isError } = useConversation();

  const isMatchDeleted = useMemo(() => !!conversationResult?.data?.match?.deletedAt, [conversationResult]);

  useEffect(() => {
    if (id && !isNumber(id)) {
      navigate(AppRoutes.chat, { replace: true });
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id && isNumber(id) && !isLoading && (isError || !conversationResult?.data)) {
      navigate(AppRoutes.chat, { replace: true });
    }
  }, [id, isLoading, isError, conversationResult, navigate]);

  return (
    <SocketProvider>
      <ChatProvider>
        <Stack sx={{ mt: 1 }}>
          <Box sx={{ mb: 2.5 }}>
            <TopPage title="チャット管理" enablePageBack={false} />
            <ChatPageContainer>
              <RoomListContainer>
                <RoomList />
              </RoomListContainer>
              <ChatContainer>
                {id ? (
                  <ChatContentWrapper ref={contentWrapperRef}>
                    <StickyRoomHead ref={headerRef}>
                      <RoomHead />
                    </StickyRoomHead>
                    <FlexRoom key={id} />
                    <InputMsg contentWrapperRef={contentWrapperRef} headerRef={headerRef} disabled={isMatchDeleted} />
                  </ChatContentWrapper>
                ) : (
                  <NoneSelectedRoom />
                )}
              </ChatContainer>
            </ChatPageContainer>
          </Box>
        </Stack>
      </ChatProvider>
    </SocketProvider>
  );
};

const ChatPageContainer = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 0 8px;
  width: 100%;
  color: black;
  height: calc(100vh - 200px);
`;

const RoomListContainer = styled(Box)`
  width: 300px;
  height: calc(100% - 16px);
  /* padding: 8px; */
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: auto;
`;

const ChatContainer = styled(Box)`
  padding: 8px;
  flex: 1;
  display: flex;
  gap: 16px;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  position: relative;
`;

const ChatContentWrapper = styled(Box)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 16px;
`;

const StickyRoomHead = styled(Box)`
  position: sticky;
  top: 0;
  z-index: 10;
`;
